import common from './ko/common';

// pages
import homePage from './ko/pages/home';
import errorsPage from './ko/pages/errors';
import sessionPage from './ko/pages/session';
import studentPage from './ko/pages/student';
import teacherPage from './ko/pages/teacher';
import preSettingModulesPage from './ko/pages/preSettingModules';
import avatarsPage from './ko/pages/avatars';
import protoWordPage from './ko/pages/protoWord';
import studentHomePage from './ko/pages/student/home';
import teacherSessionResultPage from './ko/pages/teacher/sessionResult';

// components - UI
import uiComponents from './ko/components/ui';

// components - modules
import moduleCommon from './ko/components/modules/common';
import cardWriting from './ko/components/modules/cardWriting';
import correctTheMistakes from './ko/components/modules/correctTheMistakes';
import seedLetter from './ko/components/modules/seedLetter';
import oxQuiz from './ko/components/modules/oxQuiz';
import segmentedReading from './ko/components/modules/segmentedReading';
import sentenceOrdering from './ko/components/modules/sentenceOrdering';
import wordCheck from './ko/components/modules/wordCheck';
import wordSelection from './ko/components/modules/wordSelection';
import wordWriting from './ko/components/modules/wordWriting';

// components - session
import sessionCommon from './ko/components/session/common';
import sessionResults from './ko/components/session/results';

// components - teacher
import teacherComponents from './ko/components/teacher';

// components - layers
import teacherStarLayer from './ko/components/layers/teacherStarLayer';
import focusScreenLayer from './ko/components/layers/focusScreenLayer';

// components - proto-word
import protoWord from './ko/components/proto-word/index';

const messages = {
    ko: {
        ...common,
        pages: {
            home: homePage,
            errors: errorsPage,
            session: sessionPage,
            student: {
                ...studentPage,
                home: studentHomePage,
            },
            teacher: {
                ...teacherPage,
                sessionResult: teacherSessionResultPage,
            },
            preSettingModules: preSettingModulesPage,
            avatars: avatarsPage,
            protoWord: protoWordPage,
        },
        components: {
            ui: uiComponents,
            protoWord: {
                ...protoWord,
            },
            layers: {
                teacherStarLayer,
                focusScreenLayer,
            },
            session: {
                common: sessionCommon,
                results: sessionResults,
            },
            modules: {
                common: moduleCommon,
                cardWriting,
                correctTheMistakes,
                seedLetter,
                oxQuiz,
                segmentedReading,
                sentenceOrdering,
                wordCheck,
                wordSelection,
                wordWriting,
            },
            teacher: teacherComponents,
        },
    },
};

export default messages;
